module.exports = __webpack_public_path__ + "img/DAVID_CANNON_35-rs.eb6ebd02.jpg";